// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241041/js/" + chunkId + "." + {"44":"aec06c5a","225":"a020b0d5","481":"f717a3c6","486":"44eaaf79","770":"73c504c7"}[chunkId] + ".0.4029741293914463.chunk.js";
};